import { connect, MapDispatchToProps } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { contentCountsRequest } from '~src/spacesPlatform/actions/ContentCountsActions';
import { selectContentCounts } from '~src/spacesPlatform/selectors/ContentCountsSelector';

import { CompositeSessionInfoSelectors } from '../bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '../bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '../bootstrap/redux/state/AppState';
import { CatalogBrowserHostDispatchProps, ConnectedCatalogBrowserHostProps, WrappedCatalogBrowserHost } from './CatalogBrowserHost';

const mapStateToProps: MapStateToProps<ConnectedCatalogBrowserHostProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state),
  assetCountResult: selectContentCounts<'catalog'>(state, 'catalog'),
});

const mapDispatchToProps: MapDispatchToProps<CatalogBrowserHostDispatchProps, ConnectedCatalogBrowserHostProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedAssetsCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedCatalogBrowserHost = connect(mapStateToProps, mapDispatchToProps)(WrappedCatalogBrowserHost);
